import { FeatureGoods } from './vo/feature-goods.model';
import { Feature } from './vo/feature.model';
import { UpdateFeatureGoodsList } from './vo/update-feature-goods-list.model';

/**
 * 特集商品付替画面の値を管理するクラス
 *
 * @export KYMW7005Model
 * @class KYMW7005Model
 */
export class KYMW7005Model {
	// 遷移元クエリパラメータ
	queryParams: { [key:string]: string};

	// 変更内容リスト
	updateFeatureGoodsList: UpdateFeatureGoodsList[] = [];

	// 特集商品提案状況一覧
	featureList: Feature[] = [];

	// 付替対象商品一覧
	featureGoods: FeatureGoods[] = [];

	// 付替対象商品一覧編集用
	featureGoodsEdit: FeatureGoods[] = [];

    // 発注単位区分
  orderUnitTypeListSearchData = [] as any[];

	// 全件数
	totalNum = 0;

	// 件数表示・表示開始件数
  startDispNum = 0;
	
	// 件数表示・表示終了件数
  endDispNum = 0;

	// ページ
	pageNo = 1;

  /** ページャー.戻るボタンの制御フラグ */
  btnBackEnabled = false;

  /** ページャー.進むボタンの制御フラグ */
  btnNextEnabled = false;

	// 保存ボタンの活性・非活性制御用
	isButtonsDisabled = false;

	// 表示タイトル
	isDisplayTitle = 1;
}
